import Layout from "../components/Layout";
import { usePOS } from "../context/POSContext";
import { Link } from "react-router-dom";

export const Dashboard = () => {
    const { currentOrder, tables } = usePOS();

    return (
        <Layout>
            <div className="flex flex-grow overflow-hidden">
                <div className="container mx-auto p-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <Link 
                            to="/orders" 
                            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                        >
                            <h2 className="text-xl font-semibold mb-2">Voir les états des commandes</h2>
                            <p className="text-gray-600">Gérer et modifier le statut des commandes</p>
                        </Link>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

